module.exports = __webpack_public_path__ + "img/01020401.2cedcf79.png";